import { nprogress } from '../../services/utilities';
import createNedGlobeApiService from '../../services/api/newapi';
import { getErrorMessage } from '../../services/errorLog';
import nedglobeOpenApi from '../../services/api/nedglobe';

export const actions = {
    async setApplicationConfiguration({ commit, dispatch }) {
        const config = await dispatch('useApiData', { name: 'GetWebAppConfiguration' });
        commit('SET_APPLICATION_CONFIG', config.data);
    },

    // v1 api
    getNedglobeApiInstance(store) {
        return nedglobeOpenApi(store);
    },

    async useApiData({ dispatch }, { name, parameters, data, config, useLoader }) {
        if (useLoader) {
            dispatch('setLoader', { loading: true });
        }
        const service = await dispatch('getNedglobeApiInstance');
        try {
            return await service[name](parameters, data, config);
        } catch (error) {
            throw getErrorMessage(error);
        } finally {
            if (useLoader) {
                dispatch('setLoader', { loading: false });
            }
        }
    },

    // legacy api
    getApiInstance({ state, getters, dispatch }) {
        return createNedGlobeApiService(
            state.appConfig,
            getters.endpoint,
            state.requiresAuthentication,
            state.accessToken,
            () => dispatch('refreshLoginToken')
        );
    },

    async getData({ dispatch, state }, { url, params, endpoint, timeout, useLoader }) {
        if (useLoader) {
            dispatch('setLoader', { loading: true });
        }
        const service = await dispatch('getApiInstance');
        try {
            return await service.get(url, params, endpoint, timeout);
        } catch (error) {
            throw getErrorMessage(error);
        } finally {
            if (useLoader) {
                dispatch('setLoader', { loading: false });
            }
        }
    },
    async postData({ dispatch }, { url, data, endpoint, timeout, useLoader, params }) {
        if (useLoader) {
            dispatch('setLoader', { loading: true });
        }
        const service = await dispatch('getApiInstance');
        try {
            const config = params ? { params } : null;
            return service.post(url, data, endpoint, timeout, config);
        } catch (error) {
            throw getErrorMessage(error);
        } finally {
            if (useLoader) {
                dispatch('setLoader', { loading: false });
            }
        }
    },
    async putData({ dispatch }, { url, data, endpoint, timeout, useLoader }) {
        if (useLoader) {
            dispatch('setLoader', { loading: true });
        }
        const service = await dispatch('getApiInstance');
        try {
            return service.put(url, data, endpoint, timeout);
        } catch (error) {
            throw getErrorMessage(error);
        } finally {
            if (useLoader) {
                dispatch('setLoader', { loading: false });
            }
        }
    },
    async deleteData({ dispatch }, { url, data, endpoint, timeout, useLoader }) {
        if (useLoader) {
            dispatch('setLoader', { loading: true });
        }
        const service = await dispatch('getApiInstance');
        try {
            return service.delete(url, data, endpoint, timeout);
        } catch (error) {
            throw getErrorMessage(error);
        } finally {
            if (useLoader) {
                dispatch('setLoader', { loading: false });
            }
        }
    },

    setLoader(store, { loading = false, type = 'simple' }) {
        if (type === 'simple') {
            nprogress[loading ? 'start' : 'done']();
        }
        store.commit('SET_LOADING', loading);
    },

    askConfirm(store, payload) {
        // to be able to use a confirm box from anywhere using the vuex store, this implementation is created
        // implement in one (root) component like so:
        // this.askConfirmUnSubscribe = this.$store.subscribeAction(
        //     {
        //         before: (action, state) => {
        //             if (
        //                 action.type === 'askConfirm'
        //             ) {
        //                 const { message, options } = action.payload;
        //                 action.payload.msgBox = this.$bvModal.msgBoxConfirm(message, options);
        //             }
        //         }
        //     }
        // );
        // this action can be subscribed upon and a msgBox can be appended to the payload
        // this msgBox is returned (as promise)
        return payload.msgBox;
    },

    trackUserEvent({ dispatch }, data) {
        dispatch('trackInsightsEvent', { name: 'customUserEvent', properties: data });
    },

    trackInsightsEvent({ state }, data) {
        if (state.insights) {
            state.insights.trackEvent(data);
        }
    },

    trackInsightsPage({ state }, name) {
        if (state.insights) {
            state.insights.trackPageView(name);
        }
    }
};
